import _slicedToArray from "/app/vetiver/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useState, useEffect } from 'react'; //use this hook to determine if current render is on server (ssr) or client

var useIsSsr = function useIsSsr() {
  var _useState = useState(true),
      _useState2 = _slicedToArray(_useState, 2),
      isSsr = _useState2[0],
      setIsSsr = _useState2[1];

  useEffect(function () {
    setIsSsr(false);
  }, []);
  return isSsr;
};

export default useIsSsr;